import { render } from "./CategoryRecursiveGridComponent.vue?vue&type=template&id=37d9106a"
import script from "./CategoryRecursiveGridComponent.vue?vue&type=script&lang=js"
export * from "./CategoryRecursiveGridComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/components/CategoryRecursiveGridComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37d9106a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37d9106a', __exports__)) {
    api.reload('37d9106a', __exports__)
  }
  
  module.hot.accept("./CategoryRecursiveGridComponent.vue?vue&type=template&id=37d9106a", () => {
    api.rerender('37d9106a', render)
  })

}


export default __exports__